/**
 * @owner @Appboy/intelligence
 */

import type { ComponentStoreData, ComponentStoreExport } from "./types";

/**
 * Maps composer `ComponentStoreData` to the step-document `component_store` shape
 * that CanvasStore metadata and React validators expect.
 */
export const toComponentStoreExport = (
  componentStoreData: ComponentStoreData | null | undefined
): ComponentStoreExport => {
  if (componentStoreData == null) {
    return {
      visible_components: [],
      deactivated_values: {},
    };
  }

  const variantMetadata: NonNullable<ComponentStoreExport["variant_metadata"]> = {};
  const visibleComponents: ComponentStoreExport["visible_components"] = [];

  Object.keys(componentStoreData.components ?? {}).forEach((name) => {
    const values = componentStoreData.components[name];
    const metadata = componentStoreData.variantMetadata?.[name] ?? [];
    const visibleValues: string[] = [];
    const visibleMetadata: Record<string, string>[] = [];

    (values ?? []).forEach((value, index) => {
      if (value != null && value !== "" && value.trim() !== "") {
        visibleValues.push(value);
        visibleMetadata.push(metadata[index] ?? {});
      }
    });

    visibleComponents.push({ name, values: visibleValues });
    if (visibleMetadata.some((entry) => Object.keys(entry).length > 0)) {
      variantMetadata[name] = visibleMetadata;
    }
  });

  return {
    visible_components: visibleComponents,
    deactivated_values: componentStoreData.deactivatedValues ?? {},
    ...(Object.keys(variantMetadata).length > 0 ? { variant_metadata: variantMetadata } : {}),
  };
};
